/* eslint-disable */
import { createStore, applyMiddleware, Action, StoreEnhancer } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk, { ThunkAction, ThunkDispatch } from "redux-thunk";

import rootReducer, { appState } from "./reducers";

// ---- middleware ----//
const middlewares = [thunk];
const middlewareEnhancer = applyMiddleware(...middlewares);

const enhancers = [middlewareEnhancer];
const composedEnhancers: StoreEnhancer<unknown, unknown> = composeWithDevTools(
  ...enhancers
);
// rehydrate state on app start
const initialState = {};
// ---- store ----//
const store = createStore(rootReducer, initialState, composedEnhancers);

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type Dispatch<S> = ThunkDispatch<S, null, Action<string>>;
export type AppDispatch = Dispatch<RootState>;

export type RootState = ReturnType<typeof rootReducer>;

export { store, appState };

if (import.meta) {
  // eslint-disable-next-line
  if (process.env.NODE_ENV !== "production" && import.meta?.hot) {
    import.meta.hot.accept("./reducers", () =>
      store.replaceReducer(rootReducer)
    );
  }
} else if (process.env.NODE_ENV !== "production" && (module as any).hot) {
  (module as any).hot.accept("./reducers", () =>
    store.replaceReducer(rootReducer)
  );
}
